import { Controller } from "@hotwired/stimulus"

// Phase 2.6 Tier 2 — Risk detail tab switcher. Drives Mitigations /
// Links / History panels on the risk show page. `switchTo` lets other
// controllers focus a tab programmatically (the "ready to resolve?"
// banner uses it to send the user to the Mitigations tab to record
// effectiveness ratings before resolving).
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { default: { type: String, default: "mitigations" } }

  connect() {
    if (this.hasPanelTarget) {
      this._activate(this.defaultValue)
    }
  }

  switch(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    this._activate(tab)
  }

  // Programmatic activation by name — used by the resolve banner and
  // the rate-effectiveness flow so other controllers can hop tabs.
  switchTo(event) {
    event?.preventDefault?.()
    const target = event?.currentTarget?.dataset?.tabTargetName
    if (target) this._activate(target)
  }

  _activate(name) {
    this.tabTargets.forEach(t => {
      const active = t.dataset.tab === name
      t.classList.toggle("border-brand", active)
      t.classList.toggle("text-brand", active)
      t.classList.toggle("font-medium", active)
      t.classList.toggle("border-transparent", !active)
      t.classList.toggle("text-gray-500", !active)
      t.classList.toggle("hover:text-gray-800", !active)
    })

    if (this.hasPanelTarget) {
      this.panelTargets.forEach(p => {
        p.classList.toggle("hidden", p.dataset.panel !== name)
      })
    }
  }
}
